// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import { session } from './session'
import { FeathersVuex } from '@/plugins/feathers-client'
//import auth from './store.auth'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
Vue.use(FeathersVuex)

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  false,
  // Only include .js files (prevents duplicate imports`)
  /\.js$/
)
const servicePlugins = requireModule
  .keys()
  .map(modulePath => requireModule(modulePath).default)

export default new Vuex.Store({
  modules: {
    session,
  },
  plugins: [...servicePlugins, createPersistedState({
    paths: ['session']
  })]
})
